import useQueryWithState from "./use_query_with_state";
import loadTosAcceptances from "../actions/react_query/load_tos_acceptances";
import getTosAcceptances from "../services/getters/get_tos_acceptances";
import useAvvirSelector from "../services/component_helpers/component_effects/use_avvir_selector";
import getUser from "../services/getters/base_getters/get_user";

const useTosAcceptances = () => {
  const user = useAvvirSelector(getUser);
  return useQueryWithState(
    ["useTosAcceptances"],
    loadTosAcceptances,
    getTosAcceptances,
    {enabled: !!user},
    {},
  );
};

export default useTosAcceptances;
